import { render, staticRenderFns } from "./CostDiffRuleAdd.vue?vue&type=template&id=3165f750&scoped=true"
import script from "./CostDiffRuleAdd.vue?vue&type=script&lang=js"
export * from "./CostDiffRuleAdd.vue?vue&type=script&lang=js"
import style0 from "./CostDiffRuleAdd.vue?vue&type=style&index=0&id=3165f750&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3165f750",
  null
  
)

export default component.exports